<div class="container-fluid">
  <div class="pt-4">
    <div class="d-flex justify-content-between align-items-center my-3 mt-4">
      <h4 class="fw-bold lh-sm">
        {{ 'congratulations' | transloco }}, {{ user?.firstName }} {{ user?.lastName }}!
      </h4>
      <button (click)="changePasswordModal()" type="button" class="btn btn-outline-primary">
        {{ 'change_password' | transloco }}
      </button>
    </div>
  </div>

  <app-dashboard [listMenuItems]="navigationPatient"></app-dashboard>
  <app-change-password-modal (formData)="changePassword($event)"   [whoSignIn]="UserTypeEnum.patient" [isLoading]="isLoading"></app-change-password-modal>
</div>
